import { createToast } from '@maui/elements'
import {
  useDeliveryProfileQuery,
  useUpdateDeliveryProfileMutation,
  useCreateDeliveryProfileMutation
} from '@nautilusjs/mati-apis'

const normalizeForSubmit = (data, user) => ({
  ...data,
  enableDayLightSavings: !!data.enableDayLightSavings.length,
  format: data.format.length ? 'TEXT' : 'HTML',
  deliveryDays: data.deliveryFreq === 'HOURLY' ? [] : data.deliveryDays,
  deliveryCycle: data.deliveryFreq === 'DAILY' ? 'SELECTED_DAYS' : 'IMMEDIATE',
  emailAddress: user.email,
  userID: user.email,
  companyID: user.orgUuid,
})

export const useDeliveryProfile = ({ user, onClose, editData }) => {
  const { data, isLoading } = useDeliveryProfileQuery(editData?.id,
    {
      adapter: 'profile',
      enabled: !!editData?.id,
      refetchOnWindowFocus: false,
      staleTime: Infinity
    })

  const { mutate: updateExisting, isLoading: isUpdating, error: updateError } = useUpdateDeliveryProfileMutation(editData?.id, {
    onSuccess: () => {
      createToast({
        variant: 'success',
        title: 'Success',
        message: 'Profile updated successfully',
        duration: 5000
      })
      onClose()
    },
    onError: () => {
      createToast({
        variant: 'error',
        title: 'Error',
        message: 'There was an error updating your profile; please try again',
        duration: 15000
      })
    }
  })
  const { mutate: createNew, isLoading: isCreating, error: createError } = useCreateDeliveryProfileMutation({
    onSuccess: () => {
      createToast({
        variant: 'success',
        title: 'Success',
        message: 'Profile created successfully',
        duration: 5000
      })
      onClose()
    },
    onError: () => {
      createToast({
        variant: 'error',
        title: 'Error',
        message: 'There was an error creating your profile; please try again',
        duration: 15000
      })
    }
  })

  const onSubmit = (data) => {
    const payload = normalizeForSubmit(data, user)
    if (editData?.id) {
      updateExisting(payload)
    } else {
      createNew(payload)
    }
  }

  const error = updateError || createError
  const isSubmitting = isUpdating || isCreating

  return {
    data,
    isLoading,
    onSubmit,
    isSubmitting,
    error
  }
}
